angular.module('hjApp').component('userDataLoader', {
    template: require('./user-data-loader.component.html'),
    controller: function userDataLoader() {}
});
